import { cn } from '@zealot/ui/lib/utils';
import { Loader2 } from 'lucide-react';
import type * as React from 'react';
import { Button } from './button';

// gloss
type LoadMoreButtonProps = {
  onClick: () => void;
  isLoading?: boolean;
  children?: React.ReactNode;
  className?: string;
};

// gloss
const LoadMoreButton = ({ onClick, isLoading = false, children = 'Show more', className }: LoadMoreButtonProps) => {
  return (
    <div className="flex justify-center">
      <Button
        data-slot="load-more-button"
        variant="ghost"
        size="sm"
        onClick={onClick}
        disabled={isLoading}
        className={cn('text-muted-foreground hover:text-primary', className)}
      >
        {isLoading ? (
          <>
            <Loader2 className="animate-spin" />
            Loading…
          </>
        ) : (
          children
        )}
      </Button>
    </div>
  );
};

export type { LoadMoreButtonProps };
export { LoadMoreButton };
